// extracted by mini-css-extract-plugin
module.exports = {"leader-button-container":"styles__leader-button-container___1wodc","leader-avatar":"styles__leader-avatar___2wkCn","leader-name":"styles__leader-name___k4PNA"};